import 'core-js'; // nessecary for p5js
import p5 from 'p5/lib/p5.min';

import $ from 'jquery';
// TODO: Replace p5js with vanilla js

const signatureSketch = p => {
  p.lines = [];
  p.currentLine = [];

  p.setup = () => {
    p.createCanvas(500, 200);
  };

  p.touchMoved = () => {
    if (p.currentLine.length != 0) return false;
    if (pointInView(p.mouseX, p.mouseY)) return false;
    return true;
  };

  let pointInView = (x, y) => x >= 0 && x <= p.width && y >= 0 && y <= p.height;

  p.draw = function () {
    p.background(255);
    p.noFill();

    p.stroke(0);
    p.strokeWeight(1);
    const spacingLine = 20;
    p.line(spacingLine, 0.85 * p.height, p.width - spacingLine, 0.85 * p.height);

    p.strokeWeight(2);
    p.stroke(0);
    for (const line of [p.currentLine, ...p.lines]) {
      p.beginShape();
      for (const point of line) {
        p.vertex(point.x, point.y);
      }
      p.endShape();
    }

    if (p.mouseIsPressed == true) {
      if (p.currentLine.length == 0 && !pointInView(p.mouseX, p.mouseY)) return;

      p.currentLine.push(p.createVector(
          Math.round(p.mouseX * 10) / 10,
          Math.round(p.mouseY * 10) / 10
      ));
    } else if (p.currentLine.length > 0) {
      $(p.canvas).removeClass('redBorder');
      let newLine = [p.currentLine[0], ...rdp(p.currentLine), p.currentLine[p.currentLine.length - 1]];
      // remove same points after each other
      newLine = newLine.filter((point, i, arr) => {
        if (i == 0) return true;
        return !point.equals(arr[i - 1]);
      });
      p.lines.push(newLine);
      p.currentLine = [];
    }
  };

  let rdp = (points = [], epsilon = 0.5) => {
    const p1 = points[0];
    const p2 = points[points.length - 1];
    const {
      index,
      dist,
    } = furthestPoint(p1, p2, points);

    if (dist > epsilon) {
      return [...rdp(points.slice(0, index + 1), epsilon), ...rdp(points.slice(index).slice(1), epsilon)];
    } else {
      return p1 == p2 ? [p1] : [p1, p2];
    }
  };

  let furthestPoint = (p1, p2, points) => {
    let dmax = 0;
    let maxI = -1;
    for (let i = 0; i < points.length; i++) {
      const dtemp = perpendicularDist(points[i], p1, p2);

      if (dtemp > dmax) {
        dmax = dtemp;
        maxI = i;
      }
    }

    return {
      index: maxI,
      dist: dmax,
    };
  };

  let perpendicularDist = (po, p1, p2) => {
    if (p1 == po || po == p2) return 0;
    const a = po.copy().sub(p1);
    const b = po.copy().sub(p2);
    const c = a.cross(b).mag();
    const d = p2.copy().sub(p1).mag();
    return c / d;
  };
};

const sketches = {};
for (const signatureDiv of $('.signature').toArray()) {
  const id = $(signatureDiv).attr('element-id');
  const sketchContainer = $(signatureDiv).find('.signatureField')[0];
  const s = new p5(signatureSketch, sketchContainer);

  $(signatureDiv).find('.undoSignature').click(() => { s.lines.pop(); });
  $(signatureDiv).find('.resetSignature').click(() => { s.currentLine = []; s.lines = []; });

  sketches[id] = s;
}

export default sketches;
